import { render, staticRenderFns } from "./AgregarArchivo.vue?vue&type=template&id=0c88ae16&scoped=true"
import script from "./AgregarArchivo.vue?vue&type=script&lang=js"
export * from "./AgregarArchivo.vue?vue&type=script&lang=js"
import style0 from "./AgregarArchivo.vue?vue&type=style&index=0&id=0c88ae16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88ae16",
  null
  
)

export default component.exports